window.addEventListener("load", (event) => {
    const promoBtns = document.querySelectorAll('.promo-cta button, .pdp-promo__cta button');

    promoBtns.forEach((btn) => {
        btn.addEventListener('click', function () {
            const discountCode = this.dataset.discount;
            const currentUrl = window.location.pathname + window.location.search;
            const encodedRedirect = encodeURIComponent(currentUrl);

            if (discountCode) {
                navigator.clipboard.writeText(discountCode).then(() => {
                    this.innerHTML = `<svg viewBox="0 0 408.576 408.576"><path d="M204.288 0C91.648 0 0 91.648 0 204.288s91.648 204.288 204.288 204.288 204.288-91.648 204.288-204.288S316.928 0 204.288 0zm114.176 150.528-130.56 129.536c-7.68 7.68-19.968 8.192-28.16.512L90.624 217.6c-8.192-7.68-8.704-20.48-1.536-28.672 7.68-8.192 20.48-8.704 28.672-1.024l54.784 50.176L289.28 121.344c8.192-8.192 20.992-8.192 29.184 0s8.192 20.992 0 29.184z"/></svg>`;
                    setTimeout(() => {
                        window.location.href = `/discount/${discountCode}?redirect=${encodedRedirect}`;
                    }, 1000);
                }).catch((err) => {
                    console.error('Unable to copy discount code:', err);
                    window.location.href = `/discount/${discountCode}?redirect=${encodedRedirect}`;
                });
            }
        });
    });
});